const API_BASE = process.env.UNIFIED_UPSELL_API_URL;
const API_KEY = process.env.UNIFIED_UPSELL_API_KEY;
const ROKT_SANDBOX_WIDGET_MODE = process.env.ROKT_SANDBOX_WIDGET_MODE;
const INVENTORY_TYPE_RESALE = 'resale';
const PAGE_IDENTIFIER = 'checkout.upsell';

const ON_FAILURE_KEY = 'onFailure';
const ON_FAILURE_REASON = 'Testing reason message';
const ON_LOADED_KEY = 'onLoaded';
const ON_CARTUPDATED_KEY = 'onCartUpdated';

const EVENT_DELIVERY_COUNTRY_CHANGE = 'UPSERT_DELIVERY_DETAILS';
const EVENT_DELIVERY_METHOD_CHANGE = 'UPSERT_ALERT';
const EVENT_HIDE_MESSAGE = 'DELETE_ALERT';
const EVENT_UPDATE_CART_ITEM = 'V2_UPDATE_CART_ITEM';

export {
  API_BASE,
  API_KEY,
  EVENT_DELIVERY_COUNTRY_CHANGE,
  EVENT_DELIVERY_METHOD_CHANGE,
  EVENT_HIDE_MESSAGE,
  EVENT_UPDATE_CART_ITEM,
  INVENTORY_TYPE_RESALE,
  ON_CARTUPDATED_KEY,
  ON_FAILURE_KEY,
  ON_FAILURE_REASON,
  ON_LOADED_KEY,
  PAGE_IDENTIFIER,
  ROKT_SANDBOX_WIDGET_MODE,
};
